import { render, staticRenderFns } from "./CareCampusUniChecklist.vue?vue&type=template&id=e425c0a0&scoped=true&"
import script from "./CareCampusUniChecklist.vue?vue&type=script&lang=js&"
export * from "./CareCampusUniChecklist.vue?vue&type=script&lang=js&"
import style0 from "./CareCampusUniChecklist.vue?vue&type=style&index=0&id=e425c0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e425c0a0",
  null
  
)

export default component.exports